const OPTIONS = [
  { name: "a · Espresso solid", cls: "bg-[#211307] text-[#F7F5F0] hover:bg-[#3E2818]" },
  { name: "b · Caramel (current)", cls: "bg-[#8A5730] text-white hover:bg-[#6E4526]" },
  { name: "c · Deep coffee", cls: "bg-[#5A3418] text-[#F7F5F0] hover:bg-[#3E2818]" },
  { name: "d · Espresso→caramel gradient", cls: "bg-gradient-to-r from-[#3E2818] to-[#8A5730] text-white hover:opacity-90" },
  { name: "e · Outline / ghost", cls: "bg-transparent text-[#3E2818] border border-[#3E2818]/35 hover:bg-[#3E2818] hover:text-[#F7F5F0]", clsDark: "bg-transparent text-[#F7F5F0] border border-white/35 hover:bg-[#F7F5F0] hover:text-[#211307]" },
  { name: "f · Amber gold", cls: "bg-[#EDA13A] text-[#211307] hover:bg-[#E0902B]" },
  { name: "g · Olive / sage", cls: "bg-[#5C6B3C] text-[#F7F5F0] hover:bg-[#4A5730]" },
  { name: "h · Espresso w/ amber text", cls: "bg-[#211307] text-[#EDA13A] hover:bg-[#3E2818]" },
  { name: "i · Sand / oat (for dark bg)", cls: "bg-[#EFE7D9] text-[#211307] hover:bg-white" },
  { name: "j · Sharp-edge espresso", cls: "bg-[#211307] text-[#F7F5F0] hover:bg-[#3E2818] !rounded-md" },
];

const Btn = ({ cls }) => (
  <button className={`inline-flex items-center justify-center gap-2 font-semibold text-[0.95rem] px-7 py-3.5 rounded-full transition-all duration-300 ${cls}`}>
    Talk to our experts
  </button>
);

export default function ButtonOptions() {
  return (
    <div className="min-h-screen bg-white">
      <div className="grid grid-cols-[280px_1fr_1fr] bg-[#211307] text-[#EDA13A] font-mono2 text-[10px] uppercase tracking-[0.24em]">
        <div className="px-6 py-3">Option</div>
        <div className="px-8 py-3">On Cream</div>
        <div className="px-8 py-3">On Espresso</div>
      </div>
      {OPTIONS.map((o) => (
        <div key={o.name} className="grid grid-cols-[280px_1fr_1fr] items-stretch border-b border-[#3E2818]/10">
          <div className="flex items-center px-6 py-6 text-sm font-semibold text-[#3E2818]">{o.name}</div>
          <div className="bg-[#F7F5F0] flex items-center px-8 py-6"><Btn cls={o.cls} /></div>
          <div className="bg-[#211307] flex items-center px-8 py-6"><Btn cls={o.clsDark || o.cls} /></div>
        </div>
      ))}
    </div>
  );
}
